import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { SubSink } from 'subsink';
import { Actions, ofType } from '@ngrx/effects';
import * as fromHttpErrorActions from './core/state/http-error/http-error.actions';
import {
  NotificationType,
  ShiveNotificationService,
} from './core/services/controls/shive-notification.service';
import 'reflect-metadata';
import { WINDOW } from './features/calendar/util/browser-window-ref';
import { Logger } from './shared/logging/logger';
import { environment } from '../environments/environment';
import LogRocket from 'logrocket';
import * as fromAuthActions from './auth/state/auth.actions';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  standalone: false,
})
export class AppComponent implements OnInit, OnDestroy {
  private readonly times = [];
  private fps;
  private readonly subs = new SubSink();

  // DI
  private readonly actions$ = inject(Actions);
  private readonly shiveNotificationService = inject(ShiveNotificationService);
  private readonly window = inject<Window>(WINDOW);

  constructor() {
    // Init callbacks
    this.initEvents();

    // Standard logger
    Logger.toggleLogging(environment.logging);

    if (environment.logging) {
      LogRocket.init('0appxw/shive');
    }
  }

  public render(): void {
    this.window.requestAnimationFrame(() => {
      const now = performance.now();
      while (this.times.length > 0 && this.times[0] <= now - 1000) {
        this.times.shift();
      }
      this.times.push(now);
      this.fps = this.times.length;
      document.getElementById('fps').textContent = this.fps;
      this.render();
    });
  }

  ngOnInit(): void {
    // if (!environment.production) {
    //   this.render();
    // }
    this.render();
    // throw new CustomError('Error', 'test');
    //
    // history$.subscribe(test => {
    //   console.debug('ok');
    // });
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }

  private initEvents(): void {
    this.subs.sink = this.actions$
      .pipe(ofType(fromHttpErrorActions.addHttpError))
      .subscribe((error) => {
        this.shiveNotificationService.show(NotificationType.Error, error.payload.message);
      });

    this.subs.sink = this.actions$
      .pipe(ofType(fromAuthActions.userLoggedOut))
      .subscribe(() => (this.window.location.href = 'https://shiveapp.com'));
  }
}
